import * as tslib_1 from "tslib";
import { OnDestroy, } from '@angular/core';
import { AppStateFacade } from '@app-state';
import { TranslateService } from '@ngx-translate/core';
import { UiGridIntl, } from '@uipath/angular/components/ui-grid';
import { Subject } from 'rxjs';
import { map, takeUntil, } from 'rxjs/operators';
var TRANSLATE_KEYS = [
    'grid_search_tooltip',
    'grid_search_placeholder',
    'grid_action_refresh',
    'grid_filter_option_all',
    'no_data_general',
    'grid_search_tooltip_clear',
    'clear_selection',
    'multipage_selection_info',
    'a11y_loading_page',
    'a11y_grid_refreshing',
    'a11y_grid_showing_page_no',
    'a11y_sort_direction_asc',
    'a11y_sort_direction_desc',
];
var UiTableIntl = /** @class */ (function (_super) {
    tslib_1.__extends(UiTableIntl, _super);
    function UiTableIntl(_translate, appState) {
        var _this = _super.call(this) || this;
        _this._translate = _translate;
        _this._destroyed$ = new Subject();
        _this.translateDropdownOption = function (option) {
            return !!option.translationKey ?
                _this._translate.instant(option.translationKey) :
                option.label;
        };
        _this.translateMultiPageSelectionCount = function (count) {
            if (count !== 1) {
                return count + " " + _this._translate.instant('grid_label_selected_zero_or_more');
            }
            var _a = _this._translate.instant('grid_label_selected_one_row').split('|'), first = _a[0], second = _a[1];
            return "" + (first || '') + (second || '');
        };
        _this.loadingPage = function (page) {
            return _this._translate.instant('a11y_loading_page', { page: page });
        };
        _this.loadedPage = function (page, showingItems, total) {
            return _this._translate.instant('a11y_grid_showing_page_no', { page: page, showingItems: showingItems, total: total });
        };
        _this.columnSortedAscending = function (columnTitle) {
            return _this._translate.instant('a11y_grid_sort_status', {
                columnTitle: columnTitle,
                direction: _this.ascending,
            });
        };
        _this.columnSortedDescending = function (columnTitle) {
            return _this._translate.instant('a11y_grid_sort_status', {
                columnTitle: columnTitle,
                direction: _this.descending,
            });
        };
        _this.columnUnsorted = function (columnTitle) {
            return _this._translate.instant('a11y_grid_sort_status_unsorted', {
                columnTitle: columnTitle,
            });
        };
        _this._updateLabels = function (_a) {
            var grid_search_tooltip = _a.grid_search_tooltip, grid_search_placeholder = _a.grid_search_placeholder, grid_action_refresh = _a.grid_action_refresh, grid_filter_option_all = _a.grid_filter_option_all, no_data_general = _a.no_data_general, grid_search_tooltip_clear = _a.grid_search_tooltip_clear, clear_selection = _a.clear_selection, multipage_selection_info = _a.multipage_selection_info, a11y_grid_refreshing = _a.a11y_grid_refreshing, a11y_sort_direction_asc = _a.a11y_sort_direction_asc, a11y_sort_direction_desc = _a.a11y_sort_direction_desc;
            _this.ascending = a11y_sort_direction_asc;
            _this.descending = a11y_sort_direction_desc;
            _this.searchTooltip = grid_search_tooltip;
            _this.refreshTooltip = grid_action_refresh;
            _this.clearSelectionTooltip = clear_selection;
            _this.noSelectionMessage = "0 " + _this._translate.instant('grid_label_selected_zero_or_more');
            _this.multiPageSelectionInfoTooltip = multipage_selection_info;
            _this.noFilterPlaceholder = grid_filter_option_all;
            _this.searchPlaceholder = grid_search_placeholder;
            _this.noDataMessage = no_data_general;
            _this.clearTooltip = grid_search_tooltip_clear;
            _this.pageRefreshing = a11y_grid_refreshing;
            _this.changes.next();
        };
        appState.language.value$
            .pipe(map(function () {
            return TRANSLATE_KEYS.reduce(function (translations, key) {
                translations[key] = _translate.instant(key);
                return translations;
            }, {});
        }), takeUntil(_this._destroyed$)).subscribe(_this._updateLabels);
        return _this;
    }
    UiTableIntl.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    return UiTableIntl;
}(UiGridIntl));
export { UiTableIntl };
